// import useJwt from '@core/auth/jwt/useJwt'
// import axios from '@axios'

// const { jwt } = useJwt(axios, {})

// export default jwt

// My Own Jwt
/* eslint import/no-cycle: [2, { maxDepth: 1 }] */
import axios from '@axios'
import useJwt from './customJwt/useJwt'

const { jwt } = useJwt(axios, {})

export default jwt
